function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.274 19.045v-1.731c0-.863-.374-1.654-.992-2.232a3.597 3.597 0 00-2.46-.949c-.968 0-1.845.37-2.46.949-.619.578-.993 1.37-.993 2.232v1.73h-.594c-.246 0-.445.175-.445.39v4.576c0 .215.2.39.445.39h8.092c.246 0 .446-.175.446-.39v-4.575c0-.216-.2-.39-.446-.39h-.593zm-4.829-3.127c.368-.318.846-.5 1.377-.501.53 0 1.009.183 1.376.501.365.318.6.765.6 1.27v1.758h-3.953v-1.757c0-.506.235-.953.6-1.27z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.464 1a1 1 0 011 1v2.733H21.53V2a1 1 0 112 0v2.733h4.602A2.867 2.867 0 0131 7.6v20.533A2.867 2.867 0 0128.133 31H3.867A2.867 2.867 0 011 28.133V7.6a2.867 2.867 0 012.867-2.867h4.597V2a1 1 0 011-1zM3.867 6.733A.867.867 0 003 7.6v1.8h26V7.6a.867.867 0 00-.867-.867H3.867zM29 11.4H3v16.733c0 .479.388.867.867.867h24.266a.867.867 0 00.867-.867V11.4z",
  fill: "currentColor"
})));